// FullWidth3DCarousel.jsx
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchSliders } from "../../redux/slices/sliderSlice"; // عدل المسار حسب المشروع
import "./HeroCarousel.css";

const FullWidth3DCarousel = () => {
  const { t } = useTranslation("global");
  const dispatch = useDispatch();

  const { sliders, isLoading } = useSelector((state) => state.slider);
  const [index, setIndex] = useState(0);

  const total = sliders.length;

  const nextSlide = () => setIndex((prev) => (prev + 1) % total);
  const prevSlide = () => setIndex((prev) => (prev - 1 + total) % total);

  useEffect(() => {
    AOS.init({ duration: 800 });
    dispatch(fetchSliders());
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, [total]);

  if (isLoading) return <div className="text-center py-5">Loading...</div>;
  if (!sliders || sliders.length === 0) return <div>No slides available</div>;

  return (
    <div className="carousel3d-wrapper position-relative">
      <div
        className="carousel3d-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {sliders.map((slide, i) => (
          <div className="carousel3d-slide" key={slide.id}>
            <img src={slide.image} alt={`Slide ${i + 1}`} />
          </div>
        ))}
      </div>

      <div key={index} className="carousel-caption" data-aos="fade-up">
        <h2 data-aos="flip-left" data-aos-duration="2000">
          {sliders[index].title}
        </h2>
        <p data-aos="flip-right" data-aos-duration="2000">
          {sliders[index].desc}
        </p>
        <Link
          to="/"
          className="btn btn-light mt-2 view_more"
          data-aos="flip-down"
          data-aos-duration="1000"
        >
          {t("home.requestQuote")}
        </Link>
      </div>

      <button className="carousel3d-button prev" onClick={prevSlide}>
        ‹
      </button>
      <button className="carousel3d-button next" onClick={nextSlide}>
        ›
      </button>
    </div>
  );
};

export default FullWidth3DCarousel;
